import api from './api'

export type EvidenceType = 'PHOTO' | 'VIDEO' | 'DOC' | 'AUDIO' | 'OTHER'

export interface EvidenceItem {
    id: number
    type: EvidenceType
    storageKey: string
    filename?: string
    contentType?: string
    sizeBytes?: number
    sha256: string
    createdBy: string
    createdAt: string
}
export interface EvidenceAccess {
    id: number; evidenceId: number; userId: string; action: string; ipAddress?: string; at: string
}
export interface CustodyManifest { item: EvidenceItem; chain: EvidenceAccess[] }
export interface VerifyResult { matches: boolean; storedSha256: string }

export interface RegistrationRequest {
    type?: EvidenceType
    storageKey: string
    filename?: string
    contentType?: string
    sizeBytes?: number
    sha256: string
    lat?: number; lon?: number
    retentionDays?: number
}

export const evidenceService = {
    list: async (): Promise<EvidenceItem[]> => (await api.get<EvidenceItem[]>('/api/v1/evidence')).data,
    register: async (r: RegistrationRequest): Promise<EvidenceItem> => (await api.post<EvidenceItem>('/api/v1/evidence', r)).data,
    /** Sube el archivo a MinIO y registra la custodia con el hash del servidor (E8). */
    upload: async (file: File, type: EvidenceType = 'PHOTO'): Promise<EvidenceItem> => {
        const fd = new FormData()
        fd.append('file', file)
        fd.append('type', type)
        return (await api.post<EvidenceItem>('/api/v1/evidence/upload', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })).data
    },
    chain: async (id: number): Promise<EvidenceAccess[]> => (await api.get<EvidenceAccess[]>(`/api/v1/evidence/${id}/chain`)).data,
    manifest: async (id: number): Promise<CustodyManifest> => (await api.get<CustodyManifest>(`/api/v1/evidence/${id}/manifest`)).data,
    verify: async (id: number, sha256: string): Promise<VerifyResult> => (await api.post<VerifyResult>(`/api/v1/evidence/${id}/verify`, { sha256 })).data,
}
